import { useQuery } from "react-query";

import { sendFetchRequest } from "@/utils/sendFetchRequest";

export const useFetch = <ResultType, ErrorType>(
  url: string,
  queryKey: string | string[],
  queryOptions?: {
    enabled?: boolean;
    staleTime?: number;
    retry?: number | boolean;
    refetchOnWindowFocus?: boolean;
  },
  condition = true,
  onCaptchaRequired?: () => void,
  onCaptchaRequired405?: () => void
) =>
  useQuery<ResultType, ErrorType>(
    queryKey,
    async () => {
      if (condition) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
        const token: string = await window.AwsWafIntegration.getToken();

        return sendFetchRequest(
          url,
          undefined,
          onCaptchaRequired,
          onCaptchaRequired405,
          token
        );
      }

      return {
        data: undefined,
        isLoading: false,
        isError: false,
      };
    },
    queryOptions
  );
